import React, { useState, useEffect, useMemo } from 'react';
import {
  Input, Table, Button, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import Pagination from '../ChatBot_List_Grid_Cust/Pagination';
import { useSelector, useDispatch } from 'react-redux';
import { GET_GROUP_USER_LOGS } from '../../slices/thunks';
import { convertUTCToLocal } from '../../slices/layouts/utils';
import config from '../../config';
import _ from 'lodash';
import Loader from '../../Components/Common/Loader';

const Gd_User_Log = ({ group_id }) => {

  const dispatch = useDispatch();
  const { Logs_Data = [], Total_Records, Total_Pages = 1 , Group_User_Logs_Loading } = useSelector(
    (state) => state.GroupOwner.Group_User_Logs
  );

  const [filter, setfilter] = useState({
    Page: 1,
    Per_Page: config.general_config.PER_PAGE_CONTENT,
    Sort_By: null,
    Sort_Order: null,
    Bot_Name: null,
    User_Name: null,
    Feedback: null,
    Thumbdown_Reason: null,
    Prompt_Question: null,
    Log_Creation_Datetime: null,
    Token_Used: null,
    Start_Date:null,
    End_Date:null
  });

  // Debounced dispatch
  const debouncedFetch = useMemo(
    () =>
      _.debounce((filterParams) => {
        dispatch(GET_GROUP_USER_LOGS({ Group_Id: group_id, ...filterParams }));
      }, 500),
    [group_id]
  );

  // Handle input changes
  const handleFilterChange = (key, value) => {
    const updated = { ...filter, [key]: value, Page: 1 };
    setfilter(updated);
    debouncedFetch(updated);
  };

  // Handle sorting
  const handleSort = (columnKey) => {
    let newOrder = 'ASC';
    if (filter.Sort_By === columnKey && filter.Sort_Order === 'ASC') {
      newOrder = 'DESC';
    }
    const updated = {
      ...filter,
      Sort_By: columnKey,
      Sort_Order: newOrder,
    };
    setfilter(updated);
    dispatch(GET_GROUP_USER_LOGS({ Group_Id: group_id, ...updated }));
  };

  // Pagination
  const onPageChange = (page_number) => {
    const updated = { ...filter, Page: Number.parseInt(page_number) };
    setfilter(updated);
    dispatch(GET_GROUP_USER_LOGS({ Group_Id: group_id, ...updated }));
  };

  useEffect(() => {
    dispatch(GET_GROUP_USER_LOGS({ Group_Id: group_id, Page: 1, Per_Page: filter.Per_Page }));
  }, [group_id]);

  const renderSortArrow = (key) => {
    if (filter.Sort_By === key) {
      return filter.Sort_Order === 'ASC' ? ' ↑' : ' ↓';
    }
    return '';
  };

//   const feedbackOptions = [
//   { value: 'UP', label: 'UP' },
//   { value: 'DOWN', label: 'DOWN' },
// ];
const [selectedPromptQuestion, setSelectedPromptQuestion] = useState('');
const [modal_large, setmodal_large] = useState(false);
    function tog_large() {
        setmodal_large(!modal_large);
    }

  return (
    <>
     <div className='filter-date-wrap'>
  <Input
    type="date"
    className="form-control"
    value={filter.Start_Date || ''}
    onChange={(e) => handleFilterChange('Start_Date', e.target.value)}
    placeholder='Filter from date'
  />
  <span>to</span>
  <Input
    type="date"
    className="form-control"
    value={filter.End_Date || ''}
    onChange={(e) => handleFilterChange('End_Date', e.target.value)}
    placeholder='Filter to date'
  />
  <div className='mt-3 mb-3'>
    <Button onClick={() => debouncedFetch(filter)}>GENERATE</Button>
  </div>
</div>
      <div className="table-responsive mb-1">
        <Table className="table align-middle table-nowrapg gul">
          <thead className="table-light">
            <tr>
              {[
                { key: 'Bot_info_i', label: '' },
                { key: 'Bot_Name', label: 'Bot Name' },
                { key: 'User_Name', label: 'User Name' },
                { key: 'Log_Creation_Datetime', label: 'Use Datetime' },
                { key: 'Token_Used', label: 'Token Used' },
                { key: 'Feedback', label: 'Feedback' },
                { key: 'Thumbdown_Reason', label: 'Thumb-down Reason' },
                { key: 'Prompt_Question', label: 'Prompt Question' },
              ].map(({ key, label }) => (
                <th key={key} onClick={() => handleSort(key)} style={{ cursor: 'pointer' }}>
                  {label}
                  {renderSortArrow(key)}
                  {/* <div className="input-group mt-1">
                    <Input
                      value={filter[key] || ''}
                      onChange={(e) => handleFilterChange(key, e.target.value)}
                      placeholder=""
                    />
                  </div> */}
                  {/* {key !== 'Bot_info_i' && (
                    <div className="input-group mt-1">
                      <Input
                        value={filter[key] || ''}
                        onChange={(e) => handleFilterChange(key, e.target.value)}
                        placeholder=""
                      />
                      <span className="input-group-text"><i className='ri-search-line'></i></span>
                    </div>
                  )} */}
                  {key !== 'Bot_info_i' && (
                    
                      <div>
                      {key === 'Feedback' ? (
                        <select
                          className="form-select"
                          value={filter[key] || ''}
                          onChange={(e) => handleFilterChange(key, e.target.value)}
                        >
                          <option value="">Select Feedback</option>
                          <option value="UP">UP</option>
                          <option value="DOWN">DOWN</option>
                        </select>
                      ) : (
                        <>
                        <div className="input-group mt-1 w-100">
                          <Input
                            value={filter[key] || ''}
                            onChange={(e) => handleFilterChange(key, e.target.value)}
                            placeholder=""
                          />
                          <span className="input-group-text">
                            <i className='ri-search-line'></i>
                          </span>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Group_User_Logs_Loading ? <Loader/> :  Logs_Data.length > 0 ? (
              Logs_Data.map((ele, index) => {
                const {
                  
                  Bot_Name,
                  User_Name,
                  Token_Used,
                  Feedback,
                  Thumbdown_Reason,
                  Prompt_Question,
                  Log_Creation_Datetime,
                } = ele;

                return (
                  <tr key={index}>
                    <td><span onClick={() => {
                                  setSelectedPromptQuestion(Prompt_Question);
                                  tog_large();
                                }}><i className="ri-information-line text-secondary"></i></span></td>
                    <td>{Bot_Name}</td>
                    <td>{User_Name}</td>
                    <td>{convertUTCToLocal(Log_Creation_Datetime)}</td>
                    <td>{Token_Used}</td>
                    <td> {Feedback === "UP" && <i className="ri-thumb-up-line text-secondary" />}
                          {Feedback === "DOWN" && <i className="ri-thumb-down-line text-danger" />}
                          {!Feedback && <i className="fa fa-thumbs-o-up text-muted" />}
                    </td>
                    <td>{Thumbdown_Reason}</td>
                    <td><span>{Prompt_Question}</span></td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-3">
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
               <div className="d-flex justify-content-end">
                <div className='total_entry'></div>        
                  <Pagination onPageChange={onPageChange} total_pages={Total_Pages} current_page={filter.Page} />
              </div>
    {/* Large Modal */}
      <Modal
          size="lg"
          isOpen={modal_large}
          toggle={() => {
              tog_large();
          }}
      >
          <ModalHeader className="modal-title"
              id="myLargeModalLabel" toggle={() => {
                  tog_large();
              }}
              style={{borderBottom:"1px solid #dddd", paddingBottom:"15px"}}
              >

              Prompt QUestion

          </ModalHeader>
          <ModalBody>
              {selectedPromptQuestion}
          </ModalBody>
          <div className="modal-footer">
            <Button className="btn btn-light" onClick={() => setmodal_large(false)}>Close</Button>
          </div>
      </Modal>
          
    </>
  );
};

export default Gd_User_Log;
